export const OrderDetailsType = {
    setOrderId:'setOrderId',
  
      RESET: "RESET",
      
      
    };